// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.routine-card {
  background: var(--color-white);
  width: 100%;
  border-radius: var(--radius-md);
  padding: var(--space-4);
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  box-sizing: border-box;
  border: 1px solid var(--color-border-subtle);
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.1s ease;
}

.routine-card:hover {
  border-color: var(--color-gray);
  box-shadow: var(--shadow-sm);
}

/* Main content row */
.routine-card-main {
  display: flex;
  align-items: center;
  gap: 12px;
}

/* Drag Handle */
.routine-card-drag-handle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  color: var(--color-dark-gray);
  cursor: grab;
  flex-shrink: 0;
  opacity: 0.4;
  transition: opacity 0.2s ease, color 0.2s ease;
  border-radius: 4px;
  padding: 2px;
}

.routine-card-drag-handle:hover {
  opacity: 0.8;
  color: var(--color-primary-green);
  background-color: var(--color-light-gray);
}

.routine-card-drag-handle:active {
  cursor: grabbing;
  opacity: 1;
}

/* Image Area */
.routine-card-image {
  width: 88px;
  height: 88px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.routine-card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
}

.routine-card-image-placeholder {
  width: 100%;
  height: 100%;
  background-color: var(--color-light-gray);
  border-radius: 8px;
  border: 1px dashed var(--color-gray);
}

/* Content Area */
.routine-card-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-width: 0;
  height: auto;
  min-height: 88px;
}

/* Clickable area (image + content) when card opens product detail */
.routine-card-clickable-area {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  min-width: 0;
  text-align: left;
  cursor: pointer;
  border: none;
  background: transparent;
  font: inherit;
  color: inherit;
  padding: 0;
  -webkit-tap-highlight-color: transparent;
}

.routine-card-clickable-area:focus {
  outline: 2px solid var(--color-primary-green);
  outline-offset: 2px;
  border-radius: 8px;
}

.routine-card-clickable-area:focus:not(:focus-visible) {
  outline: none;
}

.routine-card-texts {
  display: flex;
  flex-direction: column;
}

.routine-card-company {
  color: var(--color-dark-gray);
  text-transform: uppercase;
}

.routine-card-name {
  color: var(--color-black);
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .routine-card {
    width: 100%;
    padding: 12px;
    gap: 12px;
    border-radius: 16px;
  }
  
  .routine-card-image {
    width: 64px;
    height: 64px;
  }
  
  .routine-card-content {
    height: auto;
    justify-content: space-between;
    gap: 8px;
  }
  
  .routine-card-texts {
    gap: 4px;
  }
  
  .routine-card-drag-handle {
    display: none;
  }
}

/* Mobile Reordering Controls */
.routine-card-mobile-controls {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-left: 8px;
}

.mobile-reorder-button {
  background: none !important;
  border: none !important;
  padding: 4px !important;
  color: var(--color-dark-gray) !important;
  opacity: 0.6;
  transition: opacity 0.2s ease, color 0.2s ease;
}

.mobile-reorder-button:hover:not(:disabled) {
  opacity: 1;
  color: var(--color-primary-green) !important;
}

.mobile-reorder-button:disabled {
  opacity: 0.2;
  cursor: not-allowed;
}

/* Show mobile controls on mobile devices */
@media (max-width: 768px) {
  .routine-card-mobile-controls {
    display: flex;
  }
}

/* Hide mobile controls on desktop */
@media (min-width: 769px) {
  .routine-card-mobile-controls {
    display: none;
  }
}

/* Order Warning Banner */
.routine-card-order-warning {
  margin-top: 0;
} `, "",{"version":3,"sources":["webpack://./src/components/RoutineCard/RoutineCard.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,WAAW;EACX,+BAA+B;EAC/B,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,4CAA4C;EAC5C,6EAA6E;AAC/E;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,8CAA8C;EAC9C,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,iCAAiC;EACjC,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA,eAAe;AACf;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA,iBAAiB;AACjB;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB;;AAEA,oEAAoE;AACpE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,UAAU;EACV,wCAAwC;AAC1C;;AAEA;EACE,6CAA6C;EAC7C,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE;IACE,WAAW;IACX,aAAa;IACb,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,8BAA8B;IAC9B,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,uBAAuB;EACvB,wCAAwC;EACxC,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,UAAU;EACV,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,2CAA2C;AAC3C;EACE;IACE,aAAa;EACf;AACF;;AAEA,oCAAoC;AACpC;EACE;IACE,aAAa;EACf;AACF;;AAEA,yBAAyB;AACzB;EACE,aAAa;AACf","sourcesContent":[".routine-card {\n  background: var(--color-white);\n  width: 100%;\n  border-radius: var(--radius-md);\n  padding: var(--space-4);\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-3);\n  box-sizing: border-box;\n  border: 1px solid var(--color-border-subtle);\n  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.1s ease;\n}\n\n.routine-card:hover {\n  border-color: var(--color-gray);\n  box-shadow: var(--shadow-sm);\n}\n\n/* Main content row */\n.routine-card-main {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n/* Drag Handle */\n.routine-card-drag-handle {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  color: var(--color-dark-gray);\n  cursor: grab;\n  flex-shrink: 0;\n  opacity: 0.4;\n  transition: opacity 0.2s ease, color 0.2s ease;\n  border-radius: 4px;\n  padding: 2px;\n}\n\n.routine-card-drag-handle:hover {\n  opacity: 0.8;\n  color: var(--color-primary-green);\n  background-color: var(--color-light-gray);\n}\n\n.routine-card-drag-handle:active {\n  cursor: grabbing;\n  opacity: 1;\n}\n\n/* Image Area */\n.routine-card-image {\n  width: 88px;\n  height: 88px;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.routine-card-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 8px;\n}\n\n.routine-card-image-placeholder {\n  width: 100%;\n  height: 100%;\n  background-color: var(--color-light-gray);\n  border-radius: 8px;\n  border: 1px dashed var(--color-gray);\n}\n\n/* Content Area */\n.routine-card-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  min-width: 0;\n  height: auto;\n  min-height: 88px;\n}\n\n/* Clickable area (image + content) when card opens product detail */\n.routine-card-clickable-area {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex: 1;\n  min-width: 0;\n  text-align: left;\n  cursor: pointer;\n  border: none;\n  background: transparent;\n  font: inherit;\n  color: inherit;\n  padding: 0;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.routine-card-clickable-area:focus {\n  outline: 2px solid var(--color-primary-green);\n  outline-offset: 2px;\n  border-radius: 8px;\n}\n\n.routine-card-clickable-area:focus:not(:focus-visible) {\n  outline: none;\n}\n\n.routine-card-texts {\n  display: flex;\n  flex-direction: column;\n}\n\n.routine-card-company {\n  color: var(--color-dark-gray);\n  text-transform: uppercase;\n}\n\n.routine-card-name {\n  color: var(--color-black);\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .routine-card {\n    width: 100%;\n    padding: 12px;\n    gap: 12px;\n    border-radius: 16px;\n  }\n  \n  .routine-card-image {\n    width: 64px;\n    height: 64px;\n  }\n  \n  .routine-card-content {\n    height: auto;\n    justify-content: space-between;\n    gap: 8px;\n  }\n  \n  .routine-card-texts {\n    gap: 4px;\n  }\n  \n  .routine-card-drag-handle {\n    display: none;\n  }\n}\n\n/* Mobile Reordering Controls */\n.routine-card-mobile-controls {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-left: 8px;\n}\n\n.mobile-reorder-button {\n  background: none !important;\n  border: none !important;\n  padding: 4px !important;\n  color: var(--color-dark-gray) !important;\n  opacity: 0.6;\n  transition: opacity 0.2s ease, color 0.2s ease;\n}\n\n.mobile-reorder-button:hover:not(:disabled) {\n  opacity: 1;\n  color: var(--color-primary-green) !important;\n}\n\n.mobile-reorder-button:disabled {\n  opacity: 0.2;\n  cursor: not-allowed;\n}\n\n/* Show mobile controls on mobile devices */\n@media (max-width: 768px) {\n  .routine-card-mobile-controls {\n    display: flex;\n  }\n}\n\n/* Hide mobile controls on desktop */\n@media (min-width: 769px) {\n  .routine-card-mobile-controls {\n    display: none;\n  }\n}\n\n/* Order Warning Banner */\n.routine-card-order-warning {\n  margin-top: 0;\n} "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
